// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__22_Ev","range":"MonthRangeSwitch_range__2U46B","disabled":"MonthRangeSwitch_disabled__3tt8S"};